import i18n from 'i18n-js'

const languages = ['en']

i18n.translations = languages.reduce((parent, child) => {
  parent[child] = require(`./${child}`).default
  return parent
}, {} as any)

export default i18n
